import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { ColumnState } from 'ag-grid-enterprise';
import type {
  UserPreferences,
  UserPreferencesState,
  UserPreferencesStatus,
} from './userPreferences.model';

const initialState: UserPreferencesState = {
  isGridsPrefsInit: false,
  initialLoadingStatus: 'loading',
  needToSave: false,
  prefs: {} as UserPreferences, // Add a default value for prefs
};
export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setPreferencesInitialLoadingStatus: (state, action: PayloadAction<UserPreferencesStatus>) => {
      state.initialLoadingStatus = action.payload;
    },
    savedToBackend: (state) => {
      state.needToSave = false;
    },
    // after initial load of user preferences
    setUserPreferences: (state, action: PayloadAction<UserPreferences>) => {
      state.prefs = action.payload;
    },

    updateTablesPreferences: (
      state,
      action: PayloadAction<{ gridId: string; columnState: ColumnState[] }>,
    ) => {
      const { gridId, columnState } = action.payload;
      state.prefs.grids ??= {};
      state.prefs.grids[gridId] = { ...columnState };
      state.needToSave = true;
      state.isGridsPrefsInit = true;
    },
  },
  selectors: {
    userPreferencesInitialLoadingStatus: (state) => state.initialLoadingStatus,
    userPreferencesNeedToSave: (state) => state.needToSave,
    userPreferences: (state) => state.prefs,
  },
});

export const {
  updateTablesPreferences,
  setPreferencesInitialLoadingStatus,
  setUserPreferences,
  savedToBackend,
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;

export const {
  userPreferencesInitialLoadingStatus,
  userPreferences,
  userPreferencesNeedToSave,
} = userPreferencesSlice.selectors;
